module.exports = __webpack_public_path__ + "0bbd8e74df2271db49283db1c68aedc2.pdf";